/** Yalnız panel içindeki destek listelerine dönüş kabul edilir. */
export function supportReturnTarget(value: string) {
  return /^#\/(reports|feedback|bans|photos)(?:[/?]|$)/.test(value) ? value : null;
}
